export const programmingPortfolio = [
  {
    id: 1,
    title: "RailRoad Ink",
    img:
      "assets/railroad-ink.jpg",
    link: "https://drive.google.com/file/d/1LhyKG5dDLSPy-_b4rLi6Tf5mkKTH3Iw3/view?usp=sharing"
  },
  {
    id: 2,
    title: "Car Classification",
    img:
      "assets/car-classification.png",
    link: "http://ai.stanford.edu/~jkrause/cars/car_dataset.html"
  },

];

export const webPortfolio = [
  {
    id: 1,
    title: "GovHack 2021",
    img: "assets/transport_govhack.JPG",
    link: "https://github.com/vivekverma-create/GovHack",
  },
  {
    id: 2,
    title: "NBA Stats Explorer",
    img: "assets/NBA.jpg",
    link: "http://visualise-data.herokuapp.com/",
  },
  {
    id: 3,
    title: "SP500 Stocks",
    img: "assets/stocks.jpg",
    link: "http://visualise-data.herokuapp.com/",
  },
  {
    id: 4,
    title: "Covid-19",
    img: "assets/covid.jpg",
    link: "http://visualise-data.herokuapp.com/",
  },
  {
    id: 5,
    title: "Data Checker",
    img: "assets/data-checker.jpg",
    link: "http://visualise-data.herokuapp.com/",
  },
  
];

export const aeromodellingPortfolio = [
  {
    id: 1,
    title: "Quadcopter",
    img:
      "assets/quad.jpg",
  },
  {
    id: 2,
    title: "Electric Plane",
    img:
      "assets/toyPlane.jpg",
  },
  {
    id: 3,
    title: "Engine Plane",
    img:
      "assets/aero-modelling.jpg",
  }
];

export const electronicsPortfolio = [
  {
    id: 1,
    title: "Smart Switch",
    img:
      "assets/smart-switch.jpg",
      link:"https://drive.google.com/file/d/1qlJgkzuUviXgQJih1Yrd_tQJAyRDvjFI/view?usp=sharing"
  },
  {
    id: 2,
    title: "ThermoElectric Generator",
    img:
      "assets/electronics.jpg",
      link:"https://drive.google.com/drive/folders/1Kp46KhNzk5uCoK2JoHyo4EcnQH3qpQiU?usp=sharing"
  },

];

export const roboticsPortfolio = [
  {
    id: 1,
    title: "Spider",
    img:
      "assets/spider.jpg",
      link:"https://drive.google.com/drive/folders/1ix6A_YXMDQ6nEaSUkTy0yWG4GQVxCIMb?usp=sharing"
  },
  {
    id: 2,
    title: "Navigator",
    img:
      "assets/robotics.jpg",
  }
];
export const researchPortfolio = [
  {
    id: 1,
    title: "Magnesium Ferrite",
    img:
      "assets/paper.jpg",
      link:"https://drive.google.com/file/d/1IE4PM76iqLMkhn1zOetgLZpy1DxQuQ7i/view?usp=sharing"
  },
  {
    id: 2,
    title: "Multi-Ferroics",
    img:
      "assets/research.jpg",
      link:"https://drive.google.com/file/d/1AmlO6vKtbiUg35LK2CfYLYJ9zEKDljbc/view?usp=sharing"
  }
];
export const NewRelicPortfolio = [
  {
    id: 1,
    title: "Observability",
    img:
      "https://raw.githubusercontent.com/vivekverma-create/images/main/NewRelic%20Observability%20badge.png",
      link:"https://credentials.newrelic.com/9a7879e4-e6af-4cb9-b8c6-8509fab98c64#gs.ykz9bm"
  },
  {
    id: 2,
    title: "Programmability",
    img:
      "https://newrelic.com/sites/default/files/styles/1200w/public/2021-06/programmability-certification.png?itok=6l_lC0lg",
      link:"https://credentials.newrelic.com/6b1c8fb9-a2f0-4027-82b9-0b04fd878e91"
  }
];
export const SplunkPortfolio = [
  {
    id: 2,
    title: "Certified Core User",
    img:
      "https://www.splunk.com/content/dam/splunk2/en_us/images/training/training-course-track-core-certified-user-header-fg.png",
      link:"https://www.credly.com/badges/feaf0ed6-b241-4e82-9918-38a19047e663/public_url"
  },
  {
    id: 1,
    title: "Power User",
    img:
      "https://www.splunk.com/content/dam/splunk2/en_us/images/training/training-course-track-core-certified-power-user-header-fg.png",
      link:"https://udemy-certificate.s3.amazonaws.com/image/UC-5ab7729f-10d3-4eed-8865-49478faff592.jpg?v=1684222015000"
  }
];